import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { WarehouseInventoryLine } from './warehouse-inventory-line';
import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { WarehouseTransfer } from './warehouse-transfer';
import { Warehouse } from 'src/app/assabil-kernel/models/entities/master-data/warehouse-entity';



export class WarehouseInventory extends BaseEntity {
  
  warehouseInventoryCode    : string;
  branch                    : Branch;
  theDate                   : number;
  role                      : Role;
  person                    : Person;
  progressLevel             : number;
  warehouseTransfer         : WarehouseTransfer;
  warehouse                 : Warehouse;
  closedByRole              : Role;
  closedByPerson            : Person;
  closingDate               : Date;


  warehouseInventoryLines : WarehouseInventoryLine[] = [];

  
  constructor() {
    super()
  }
 
}
 

